<template>
  <a-card :bordered="false">
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top:16px;"
      ref="tableList"
      :columns="columns"
      base-key="orderUrl"
      params-path="order/queryZWYOrderList"
    >
    </custom-page-table>
  </a-card>
</template>

<script>
import fliggyMixins from './fliggyMixins'

export default {
  name: 'DirectOrders',
  mixins: [fliggyMixins],
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '飞猪订单号',
          dataIndex: 'proName'
        },
        {
          title: '系统订单号',
          dataIndex: 'user'
        },
        {
          title: '商品名称',
          dataIndex: 'orderSourceName'
        },
        {
          title: '同步时间',
          dataIndex: 'thirdOrderNo'
        },
        {
          title: '飞猪订单金额',
          dataIndex: 'orderSourceName'
        },
        {
          title: '采购结算金额',
          dataIndex: 'thirdOrderNo'
        },
        {
          title: '飞猪订单状态',
          dataIndex: 'orderSourceName'
        }
      ]
    }
  },
  mounted() {

  },
  methods: {}
}
</script>

<style scoped>

</style>